var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "2xl", withBgClickEvent: true },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "ModalContent",
              {
                staticClass: "relative mb-0",
                staticStyle: { "min-width": "270px", "min-height": "400px" },
              },
              [
                _c(
                  "LoadingOverlay",
                  {
                    attrs: {
                      loading: _vm.$apollo.queries.contractor_projects.loading,
                      hasData:
                        !!_vm.contractor_projects?.length &&
                        _vm.contractor_projects?.length > 0,
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "cursor-pointer flex items-center justify-center absolute customPosition",
                        attrs: {
                          disabled: _vm.timerTracker && _vm.timerRecorded,
                        },
                        on: { click: _vm.closeModal },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "14",
                              height: "15",
                              viewBox: "0 0 14 15",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M7.70807 7.5L11.2969 3.22207C11.3571 3.15098 11.3065 3.04297 11.2135 3.04297H10.1225C10.0583 3.04297 9.99674 3.07168 9.95436 3.1209L6.9944 6.64961L4.03444 3.1209C3.99342 3.07168 3.9319 3.04297 3.86627 3.04297H2.77526C2.68229 3.04297 2.6317 3.15098 2.69186 3.22207L6.28072 7.5L2.69186 11.7779C2.67838 11.7938 2.66974 11.8132 2.66695 11.8338C2.66416 11.8544 2.66734 11.8754 2.67613 11.8942C2.68491 11.9131 2.69891 11.929 2.71649 11.9402C2.73406 11.9513 2.75445 11.9571 2.77526 11.957H3.86627C3.93053 11.957 3.99205 11.9283 4.03444 11.8791L6.9944 8.35039L9.95436 11.8791C9.99537 11.9283 10.0569 11.957 10.1225 11.957H11.2135C11.3065 11.957 11.3571 11.849 11.2969 11.7779L7.70807 7.5Z",
                                fill: "black",
                                "fill-opacity": "0.45",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex flex-col sm:flex-row h-auto" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-col justify-flex-start items-center w-full",
                            class: _vm.isTimeAddedAlreadyStyle(
                              _vm.requestHoursSlot,
                              _vm.timeAggregate,
                              _vm.hoursAggregate
                            ),
                          },
                          [
                            _vm.showTrackingModes.title === ""
                              ? _c(
                                  "nav",
                                  {
                                    staticClass:
                                      "flex flex-row borderBottom gap-6 w-fit",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "text-gray-new text-lg py-3 px-1 block hover:text-blue-500 focus:outline-none",
                                        class: _vm.timerTrackerClasses,
                                        on: {
                                          click: function ($event) {
                                            return _vm.showTimerSlot()
                                          },
                                        },
                                      },
                                      [_vm._v(" Timer ")]
                                    ),
                                    !_vm.timerRunning && !_vm.timerRecorded
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "flex flex-col sm:flex-row",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "text-gray-new py-3 text-lg px-1 block hover:text-blue-500 focus:outline-none",
                                                class: _vm.rangeTrackerClasses,
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showRangeSlot()
                                                  },
                                                },
                                              },
                                              [_vm._v(" Manual ")]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticClass:
                                              "flex flex-col sm:flex-row",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "text-gray-new py-3 text-lg px-1 block hover:text-blue-500 focus:outline-none",
                                                class: _vm.rangeTrackerClasses,
                                              },
                                              [_vm._v(" Manual ")]
                                            ),
                                          ]
                                        ),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "text-gray-new py-3 text-lg px-1 block hover:text-blue-500 focus:outline-none",
                                        class: _vm.requestHoursClasses,
                                        on: {
                                          click: function ($event) {
                                            return _vm.showRequestHoursSlot()
                                          },
                                        },
                                      },
                                      [_vm._v(" Request Hours ")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.showTrackingModes.title !== ""
                              ? _c(
                                  "div",
                                  { staticClass: "h-full flex items-center" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        " You can't track two tasks at the same time. Close timer for \"" +
                                          _vm._s(_vm.showTrackingModes.title) +
                                          '" before you start a new session. '
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm.showTrackingModes.title === ""
                              ? _c("div", { staticClass: "w-full" }, [
                                  _vm.timerTracker
                                    ? _c("div", { staticClass: "w-full" }, [
                                        _c(
                                          "form",
                                          {
                                            staticClass:
                                              "w-full sm:px-6 py-4 pt-9 flex flex-col justify-between customHeight",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "w-full flex flex-col justify-between",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mb-1.5 flex items-center justify-center",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "timer",
                                                        attrs: {
                                                          id: "modaltimerLabel",
                                                        },
                                                      },
                                                      [_vm._v(" 00:00:00 ")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mb-4 items-center justify-center text-center",
                                                  },
                                                  [
                                                    !_vm.timerRecorded
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "timerButtonClasses flex flex-row gap-3 justify-center items-center w-full",
                                                            attrs: {
                                                              id: "timerbtn",
                                                              type: "button",
                                                              disabled:
                                                                !_vm.project ||
                                                                !_vm.activity,
                                                              fullWidth: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.handleTimerAction,
                                                            },
                                                          },
                                                          [
                                                            !_vm.timerRunning
                                                              ? _c(
                                                                  "svg",
                                                                  {
                                                                    attrs: {
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg",
                                                                      width:
                                                                        "16",
                                                                      height:
                                                                        "16",
                                                                      viewBox:
                                                                        "0 0 16 16",
                                                                      fill: "none",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d: "M3.35156 -0.72431C2.77344 -1.07978 2.04688 -1.0915 1.45703 -0.759466C0.867188 -0.427435 0.5 0.197565 0.5 0.877253V14.6273C0.5 15.3069 0.867188 15.9319 1.45703 16.264C2.04688 16.596 2.77344 16.5804 3.35156 16.2288L14.6016 9.35381C15.1602 9.01397 15.5 8.4085 15.5 7.75225C15.5 7.096 15.1602 6.49444 14.6016 6.15069L3.35156 -0.72431Z",
                                                                        fill: "black",
                                                                        "fill-opacity":
                                                                          "0.88",
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "svg",
                                                                  {
                                                                    attrs: {
                                                                      width:
                                                                        "16",
                                                                      height:
                                                                        "12",
                                                                      viewBox:
                                                                        "0 0 16 12",
                                                                      fill: "none",
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d: "M2.4 0C1.075 0 0 0.671875 0 1.5V10.5C0 11.3281 1.075 12 2.4 12H4C5.325 12 6.4 11.3281 6.4 10.5V1.5C6.4 0.671875 5.325 0 4 0H2.4ZM12 0C10.675 0 9.6 0.671875 9.6 1.5V10.5C9.6 11.3281 10.675 12 12 12H13.6C14.925 12 16 11.3281 16 10.5V1.5C16 0.671875 14.925 0 13.6 0H12Z",
                                                                        fill: "black",
                                                                        "fill-opacity":
                                                                          "0.88",
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.timerRunning
                                                                    ? "Stop"
                                                                    : "Start"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "mb-6" },
                                                  [
                                                    _vm.timerRecorded
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex justify-center space-x-4",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "cursor-pointer flex items-center justify-center",
                                                                on: {
                                                                  click:
                                                                    _vm.discardTimer,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    attrs: {
                                                                      width:
                                                                        "17",
                                                                      height:
                                                                        "16",
                                                                      viewBox:
                                                                        "0 0 17 16",
                                                                      fill: "none",
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d: "M0.733228 6.28699H0.410691C-0.0939834 6.28699 -0.5 5.88097 -0.5 5.3763V0.519277C-0.5 0.151206 -0.279916 -0.182715 0.0615931 -0.323113C0.403102 -0.463511 0.793941 -0.38762 1.05576 -0.125796L2.6343 1.45274C5.95832 -1.82955 11.3124 -1.81816 14.6175 1.49068C17.9377 4.81091 17.9377 10.1916 14.6175 13.5118C11.2972 16.832 5.91658 16.832 2.59635 13.5118C2.12203 13.0375 2.12203 12.2672 2.59635 11.7929C3.07067 11.3186 3.84096 11.3186 4.31528 11.7929C6.68687 14.1645 10.5308 14.1645 12.9023 11.7929C15.2739 9.42129 15.2739 5.57741 12.9023 3.20582C10.5421 0.845608 6.72861 0.834224 4.35323 3.16787L5.91279 4.73122C6.17461 4.99305 6.2505 5.38389 6.1101 5.7254C5.9697 6.06691 5.63578 6.28699 5.26771 6.28699H0.733228Z",
                                                                        fill: "black",
                                                                        "fill-opacity":
                                                                          "0.88",
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Restart"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "cursor-pointer flex items-center justify-center",
                                                                on: {
                                                                  click:
                                                                    _vm.resumeTimer,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    attrs: {
                                                                      width:
                                                                        "16",
                                                                      height:
                                                                        "16",
                                                                      viewBox:
                                                                        "0 0 16 16",
                                                                      fill: "none",
                                                                      xmlns:
                                                                        "http://www.w3.org/2000/svg",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("path", {
                                                                      attrs: {
                                                                        d: "M3.35156 -0.72431C2.77344 -1.07978 2.04688 -1.0915 1.45703 -0.759466C0.867188 -0.427435 0.5 0.197565 0.5 0.877253V14.6273C0.5 15.3069 0.867188 15.9319 1.45703 16.264C2.04688 16.596 2.77344 16.5804 3.35156 16.2288L14.6016 9.35381C15.1602 9.01397 15.5 8.4085 15.5 7.75225C15.5 7.096 15.1602 6.49444 14.6016 6.15069L3.35156 -0.72431Z",
                                                                        fill: "black",
                                                                        "fill-opacity":
                                                                          "0.88",
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "ml-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Resume"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "w-full mb-4",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "mb-5" },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Select Client: "
                                                            ),
                                                          ]
                                                        ),
                                                        _c("DropdownFilter", {
                                                          attrs: {
                                                            withoutLoading: "",
                                                            placeholder:
                                                              "Select Client",
                                                            searchable: true,
                                                            multiple: false,
                                                            value:
                                                              _vm.project_option,
                                                            options:
                                                              _vm.project_options,
                                                            customMultiStyleParent:
                                                              "customWidthInput",
                                                          },
                                                          on: {
                                                            input:
                                                              _vm.setProject,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "mb-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Select Visits: "
                                                            ),
                                                          ]
                                                        ),
                                                        _c("DropdownFilter", {
                                                          attrs: {
                                                            withoutLoading: "",
                                                            placeholder:
                                                              "Select Visits",
                                                            searchable: false,
                                                            multiple: false,
                                                            disabled:
                                                              _vm.project
                                                                ?.length === 0,
                                                            value:
                                                              _vm.activity_option,
                                                            options:
                                                              _vm.activity_options,
                                                            customMultiStyleParent:
                                                              "customWidthInput",
                                                          },
                                                          on: {
                                                            input:
                                                              _vm.setActivities,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "customFormLabel",
                                                      },
                                                      [_vm._v(" Add Notes: ")]
                                                    ),
                                                    _c("textarea", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.notes,
                                                          expression: "notes",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                      attrs: {
                                                        id: "message",
                                                        rows: "1",
                                                        placeholder: "Notes",
                                                      },
                                                      domProps: {
                                                        value: _vm.notes,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.notes =
                                                            $event.target.value
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-row gap-4",
                                              },
                                              [
                                                !_vm.timerRecorded
                                                  ? _c(
                                                      "button",
                                                      {
                                                        class:
                                                          _vm.timerTracker &&
                                                          _vm.timerRecorded
                                                            ? "disabledButton"
                                                            : "outlineTimeButton buttonHover",
                                                        attrs: {
                                                          processing:
                                                            _vm.processing,
                                                        },
                                                        on: {
                                                          click: _vm.closeModal,
                                                        },
                                                      },
                                                      [_vm._v(" Cancel ")]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "button",
                                                  {
                                                    class: !_vm.activity
                                                      ? "disabledButton"
                                                      : "blackTimeButton buttonHover",
                                                    attrs: {
                                                      disabled:
                                                        !_vm.project ||
                                                        !_vm.activity,
                                                      type: "button",
                                                      processing:
                                                        _vm.processing,
                                                    },
                                                    on: {
                                                      click: _vm.saveTimerData,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.buttonText) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm.rangeTracker
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "w-full flex flex-col justify-between customHeight",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "w-full space-y-3" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "w-full mb-4" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "mb-5" },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _vm._v(
                                                            " Select Client: "
                                                          ),
                                                        ]
                                                      ),
                                                      _c("DropdownFilter", {
                                                        attrs: {
                                                          withoutLoading: "",
                                                          placeholder:
                                                            "Select Client",
                                                          searchable: false,
                                                          multiple: false,
                                                          value:
                                                            _vm.project_option,
                                                          options:
                                                            _vm.project_options,
                                                          customMultiStyleParent:
                                                            "customWidthInput",
                                                        },
                                                        on: {
                                                          input: _vm.setProject,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _vm._v(
                                                            " Select Visits: "
                                                          ),
                                                        ]
                                                      ),
                                                      _c("DropdownFilter", {
                                                        attrs: {
                                                          withoutLoading: "",
                                                          placeholder:
                                                            "Select Visits",
                                                          searchable: false,
                                                          multiple: false,
                                                          disabled:
                                                            _vm.project
                                                              ?.length === 0,
                                                          value:
                                                            _vm.activity_option,
                                                          options:
                                                            _vm.activity_options,
                                                          customMultiStyleParent:
                                                            "customWidthInput",
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.setActivities,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "w-full" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "customFormLabel",
                                                    },
                                                    [_vm._v(" Date: ")]
                                                  ),
                                                  _c("FormDatepicker", {
                                                    attrs: {
                                                      name: "today date",
                                                    },
                                                    model: {
                                                      value: _vm.tracked_date,
                                                      callback: function ($$v) {
                                                        _vm.tracked_date = $$v
                                                      },
                                                      expression:
                                                        "tracked_date",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-col space-y-4 space-x-0 sm:flex-row sm:space-x-3 sm:space-y-0 w-full justify-between",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "w-full sm:w-1/2",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "customFormLabel",
                                                        },
                                                        [_vm._v("Start Time: ")]
                                                      ),
                                                      _c("NewTimePicker", {
                                                        attrs: {
                                                          format: "HH:mm:ss",
                                                          "auto-scroll": "",
                                                          "advanced-keyboard":
                                                            "",
                                                          "input-width": "100%",
                                                          "input-class":
                                                            "appearance-none border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                                        },
                                                        model: {
                                                          value: _vm.rangeStart,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.rangeStart = $$v
                                                          },
                                                          expression:
                                                            "rangeStart",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "w-full sm:w-1/2",
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "customFormLabel",
                                                        },
                                                        [_vm._v("End Time: ")]
                                                      ),
                                                      _c("NewTimePicker", {
                                                        attrs: {
                                                          format: "HH:mm:ss",
                                                          "auto-scroll": "",
                                                          "advanced-keyboard":
                                                            "",
                                                          "input-width": "100%",
                                                          "hide-disabled-items":
                                                            "",
                                                          "hour-range":
                                                            _vm.rangeEndHourRange,
                                                          "minute-range":
                                                            _vm.rangeEndMinuteRange,
                                                          "second-range":
                                                            _vm.rangeEndSecondRange,
                                                          "input-class":
                                                            "appearance-none border text-sm rounded-lg py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                                        },
                                                        model: {
                                                          value: _vm.rangeEnd,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.rangeEnd = $$v
                                                          },
                                                          expression:
                                                            "rangeEnd",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm.rangeEndError
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-sm text-red-400 italic",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " *End time must be greater than start time "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "w-full" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "customFormLabel",
                                                    },
                                                    [_vm._v(" Add Notes: ")]
                                                  ),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.notes,
                                                        expression: "notes",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    attrs: {
                                                      id: "message",
                                                      rows: "1",
                                                      placeholder: "Notes",
                                                    },
                                                    domProps: {
                                                      value: _vm.notes,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.notes =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-row gap-4",
                                            },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "outlineTimeButton buttonHover",
                                                  attrs: {
                                                    processing: _vm.processing,
                                                  },
                                                  on: { click: _vm.closeModal },
                                                },
                                                [_vm._v(" Cancel ")]
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  class:
                                                    !_vm.canSave ||
                                                    !_vm.project ||
                                                    !_vm.activity
                                                      ? "disabledButton"
                                                      : "blackTimeButton buttonHover",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.canSave ||
                                                      !_vm.project ||
                                                      !_vm.activity,
                                                    processing: _vm.processing,
                                                  },
                                                  on: {
                                                    click: _vm.saveTimeTrack,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(_vm.buttonText) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.requestHoursSlot
                                    ? _c("div", [
                                        _c(
                                          "form",
                                          {
                                            staticClass:
                                              "sm:px-6 py-4 pt-9 flex flex-col justify-between customHeight",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "w-full mb-4" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "mb-5" },
                                                  [
                                                    _c(
                                                      "p",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          " Select Client: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("DropdownFilter", {
                                                      attrs: {
                                                        withoutLoading: "",
                                                        placeholder:
                                                          "Select Client",
                                                        searchable: false,
                                                        multiple: false,
                                                        value:
                                                          _vm.project_option,
                                                        options:
                                                          _vm.project_options,
                                                        customMultiStyleParent:
                                                          "customWidthInput",
                                                      },
                                                      on: {
                                                        input: _vm.setProject,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "p",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          " Select Visits: "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("DropdownFilter", {
                                                      attrs: {
                                                        withoutLoading: "",
                                                        placeholder:
                                                          "Select Visits",
                                                        searchable: false,
                                                        multiple: false,
                                                        disabled:
                                                          _vm.project
                                                            ?.length === 0,
                                                        value:
                                                          _vm.activity_option,
                                                        options:
                                                          _vm.activity_options,
                                                        customMultiStyleParent:
                                                          "customWidthInput",
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.setActivities,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c("div", [
                                              _c(
                                                "div",
                                                { staticClass: "mb-4" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "customFormLabel",
                                                    },
                                                    [_vm._v(" Select time: ")]
                                                  ),
                                                  _c("NewTimePicker", {
                                                    attrs: {
                                                      format: "HH:mm:ss",
                                                      "auto-scroll": "",
                                                      "advanced-keyboard": "",
                                                      "input-class":
                                                        "appearance-none border text-sm rounded-lg w-full py-2.5 px-3 leading-tight focus:outline-none focus:shadow-outline scrollbar",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.requestTimeInput,
                                                      callback: function ($$v) {
                                                        _vm.requestTimeInput =
                                                          $$v
                                                      },
                                                      expression:
                                                        "requestTimeInput",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "mb-4" },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "customFormLabel",
                                                    },
                                                    [_vm._v(" Reason: ")]
                                                  ),
                                                  _c("textarea", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.reason,
                                                        expression: "reason",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                                                    attrs: {
                                                      id: "message",
                                                      rows: "1",
                                                      placeholder:
                                                        "Reason for requesting hours",
                                                    },
                                                    domProps: {
                                                      value: _vm.reason,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.reason =
                                                          $event.target.value
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-row gap-4",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "outlineTimeButton buttonHover",
                                                    attrs: {
                                                      processing:
                                                        _vm.processing,
                                                    },
                                                    on: {
                                                      click: _vm.closeModal,
                                                    },
                                                  },
                                                  [_vm._v(" Cancel ")]
                                                ),
                                                _c(
                                                  "button",
                                                  {
                                                    class: !_vm.canSave
                                                      ? "disabledButton"
                                                      : "blackTimeButton buttonHover",
                                                    attrs: {
                                                      disabled: !_vm.canSave,
                                                      processing:
                                                        _vm.processing,
                                                    },
                                                    on: {
                                                      click: _vm.sendRequest,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.buttonText) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm.trackedTimes
                          ? _c("div", { staticClass: "w-auto customHeight" }, [
                              _vm.requestHoursSlot
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col p-4 h-full border-l border-gray-300",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-grow overflow-y-scroll scrollbar overflow-x-visible",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "headingText" },
                                            [
                                              _vm._v(
                                                " Hours requested for " +
                                                  _vm._s(_vm.getTitle) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "relative w-full text-sm text-bold text-left dark:text-gray-400",
                                            },
                                            [
                                              _c(
                                                "tbody",
                                                { staticClass: "divide-y" },
                                                _vm._l(
                                                  _vm.requestedHours,
                                                  function (time) {
                                                    return _c(
                                                      "tr",
                                                      {
                                                        key: time.id,
                                                        staticClass:
                                                          "bg-white text-black border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600",
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass: "p-4",
                                                          },
                                                          [
                                                            time.status.toLowerCase() ===
                                                            "approved"
                                                              ? [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "approved",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Approved "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                            time.status.toLowerCase() ===
                                                            "declined"
                                                              ? [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "declined flex px-2 text-center cursor-default rounded-xl whitespace-no-wrap items-center justify-center font-normal bg-red-200 text-red-500 h-5 text-low-xs",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Declined "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                            time.status.toLowerCase() ===
                                                              "pending" ||
                                                            time.status.toLowerCase() ===
                                                              "created"
                                                              ? [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "pending",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " Pending approval "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass: "p-4",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.convertSecondsToReadable(
                                                                    time.hours
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass: "p-4",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.convertDateString(
                                                                    time.created_at
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass: "p-4",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex w-full items-center",
                                                              },
                                                              [
                                                                time.status.toLowerCase() ===
                                                                "approved"
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "opacity-25 cursor-not-allowed mr-2 flex",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                xmlns:
                                                                                  "http://www.w3.org/2000/svg",
                                                                                width:
                                                                                  "25",
                                                                                height:
                                                                                  "24",
                                                                                viewBox:
                                                                                  "0 0 25 24",
                                                                                fill: "none",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    d: "M13.6154 6.82679L6.34208 14.1032C6.01896 14.4264 5.78278 14.8272 5.65226 15.2654L4.54602 19.0247C4.46949 19.2849 4.53992 19.5634 4.72958 19.753C4.91926 19.9427 5.19771 20.0131 5.45481 19.9397C5.45483 19.9397 5.45485 19.9397 5.45487 19.9397L9.21407 18.8335L13.6154 6.82679ZM13.6154 6.82679L17.6558 10.8672L10.3762 18.1436C10.0531 18.4668 9.65229 18.7029 9.21412 18.8334L13.6154 6.82679ZM19.8856 5.83135L19.8856 5.83136C20.6608 6.60651 20.6608 7.86224 19.8856 8.63739L18.3842 10.1388L14.3438 6.09844L15.8373 4.60491V4.60803L15.8483 4.59699C16.6235 3.82184 17.8792 3.82184 18.6543 4.59697L18.6544 4.59699L19.8856 5.83135Z",
                                                                                    fill: "#010A11",
                                                                                    stroke:
                                                                                      "#333333",
                                                                                    "stroke-width":
                                                                                      "0.03125",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "mr-2 cursor-pointer flex",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.setToEditRequestedHours(
                                                                                time
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "TimeTrackingEdit"
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                time.status.toLowerCase() ===
                                                                "approved"
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "opacity-25 cursor-not-allowed mr-2 flex",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                xmlns:
                                                                                  "http://www.w3.org/2000/svg",
                                                                                width:
                                                                                  "25",
                                                                                height:
                                                                                  "24",
                                                                                viewBox:
                                                                                  "0 0 25 24",
                                                                                fill: "none",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    d: "M9.73896 4.56015L9.739 4.56006C9.90509 4.22481 10.2465 4.01562 10.6188 4.01562H14.3813C14.7535 4.01562 15.0949 4.22481 15.261 4.56006L15.261 4.56015L15.486 5.00703L15.4904 5.01562H15.5H18.5C19.0445 5.01562 19.4844 5.4555 19.4844 6C19.4844 6.5445 19.0445 6.98438 18.5 6.98438H6.5C5.9555 6.98438 5.51562 6.5445 5.51562 6C5.51562 5.4555 5.9555 5.01562 6.5 5.01562H9.5H9.50963L9.51396 5.00703L9.73896 4.56015ZM6.51562 8.01562H18.4844V18C18.4844 19.0945 17.5945 19.9844 16.5 19.9844H8.5C7.4055 19.9844 6.51562 19.0945 6.51562 18V8.01562ZM9.5 9.98438C9.21637 9.98438 8.98438 10.2164 8.98438 10.5V17.5C8.98438 17.7836 9.21637 18.0156 9.5 18.0156C9.78363 18.0156 10.0156 17.7836 10.0156 17.5V10.5C10.0156 10.2164 9.78363 9.98438 9.5 9.98438ZM12.5 9.98438C12.2164 9.98438 11.9844 10.2164 11.9844 10.5V17.5C11.9844 17.7836 12.2164 18.0156 12.5 18.0156C12.7836 18.0156 13.0156 17.7836 13.0156 17.5V10.5C13.0156 10.2164 12.7836 9.98438 12.5 9.98438ZM15.5 9.98438C15.2164 9.98438 14.9844 10.2164 14.9844 10.5V17.5C14.9844 17.7836 15.2164 18.0156 15.5 18.0156C15.7836 18.0156 16.0156 17.7836 16.0156 17.5V10.5C16.0156 10.2164 15.7836 9.98438 15.5 9.98438Z",
                                                                                    fill: "#010A11",
                                                                                    stroke:
                                                                                      "#333333",
                                                                                    "stroke-width":
                                                                                      "0.03125",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "mr-2 cursor-pointer flex",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.deleteRequestedHours(
                                                                                time.id
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "TimeTrackingDelete"
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                time.status.toLowerCase() ===
                                                                "declined"
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "cursor-pointer flex",
                                                                        on: {
                                                                          click:
                                                                            () =>
                                                                              _vm.$emit(
                                                                                "openRequestedHoursDeclineReasonModal",
                                                                                time
                                                                              ),
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                width:
                                                                                  "9",
                                                                                height:
                                                                                  "12",
                                                                                viewBox:
                                                                                  "0 0 9 12",
                                                                                fill: "none",
                                                                                xmlns:
                                                                                  "http://www.w3.org/2000/svg",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    "fill-rule":
                                                                                      "evenodd",
                                                                                    "clip-rule":
                                                                                      "evenodd",
                                                                                    d: "M4.90781 5.34058e-05C5.13514 5.34058e-05 5.35316 0.0948742 5.5139 0.263657L7.86894 2.73645C8.02969 2.90523 8.12 3.13415 8.12 3.37285V11.1001C8.12 11.5971 7.73624 12.0001 7.26285 12.0001H0.977138C0.503751 12.0001 0.119995 11.5971 0.119995 11.1001V0.900053C0.119995 0.402997 0.503751 5.34058e-05 0.977138 5.34058e-05H4.90781ZM1.83428 3.00005H4.12V4.20005H1.83428V3.00005ZM6.40571 5.40005V6.60005H1.83428V5.40005H6.40571ZM1.83428 9.00005V7.80005H5.83428V9.00005H1.83428Z",
                                                                                    fill: "#1A7BEE",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "textBlue" },
                                            [
                                              _vm._v(
                                                " Total Hours Requested " +
                                                  _vm._s(
                                                    _vm.convertSecondsToReadable(
                                                      _vm.hoursAggregate
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col p-4 h-auto sm:rounded-lg",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-grow overflow-auto scrollbar overflow-x-visible customHeight",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "headingText" },
                                            [
                                              _vm._v(
                                                " Hours tracked for " +
                                                  _vm._s(_vm.getTitle) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "relative w-full text-sm text-bold text-left dark:text-gray-400",
                                            },
                                            [
                                              _vm.trackedTimes
                                                ? _c(
                                                    "tbody",
                                                    { staticClass: "divide-y" },
                                                    _vm._l(
                                                      _vm.trackedTimes,
                                                      function (time) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key: time.id,
                                                            staticClass:
                                                              "bg-white text-black border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 customHeight",
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-4",
                                                              },
                                                              [
                                                                time.status.toLowerCase() ===
                                                                "approved"
                                                                  ? [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "approved",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Approved "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  : _vm._e(),
                                                                time.status.toLowerCase() ===
                                                                "declined"
                                                                  ? [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "declined flex px-2 text-center cursor-default rounded-xl whitespace-no-wrap items-center justify-center font-normal bg-red-200 text-red-500 h-5 text-low-xs",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Declined "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  : _vm._e(),
                                                                time.status.toLowerCase() ===
                                                                  "pending" ||
                                                                time.status.toLowerCase() ===
                                                                  "created"
                                                                  ? [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "pending",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " Pending approval "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  : _vm._e(),
                                                              ],
                                                              2
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-4",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.convertSecondsToReadable(
                                                                        time.time
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-4",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.convertDateString(
                                                                        time.tracked_date
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "p-4",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "flex w-full items-center",
                                                                  },
                                                                  [
                                                                    time.status.toLowerCase() ===
                                                                    "approved"
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "opacity-25 cursor-not-allowed mr-2 flex",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "TimeTrackingEdit"
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "mr-2 cursor-pointer flex",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.setToEdit(
                                                                                    time
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "TimeTrackingEdit"
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                    time.status.toLowerCase() ===
                                                                    "approved"
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "opacity-25 cursor-not-allowed mr-2 flex",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "TimeTrackingDelete"
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "mr-2 cursor-pointer flex",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteTrackedTime(
                                                                                    time.id
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "TimeTrackingDelete"
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                    time.status.toLowerCase() ===
                                                                    "declined"
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "cursor-pointer flex",
                                                                            on: {
                                                                              click:
                                                                                () =>
                                                                                  _vm.$emit(
                                                                                    "openDeclineReasonModal",
                                                                                    time
                                                                                  ),
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "svg",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    width:
                                                                                      "9",
                                                                                    height:
                                                                                      "12",
                                                                                    viewBox:
                                                                                      "0 0 9 12",
                                                                                    fill: "none",
                                                                                    xmlns:
                                                                                      "http://www.w3.org/2000/svg",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "path",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        "fill-rule":
                                                                                          "evenodd",
                                                                                        "clip-rule":
                                                                                          "evenodd",
                                                                                        d: "M4.90781 5.34058e-05C5.13514 5.34058e-05 5.35316 0.0948742 5.5139 0.263657L7.86894 2.73645C8.02969 2.90523 8.12 3.13415 8.12 3.37285V11.1001C8.12 11.5971 7.73624 12.0001 7.26285 12.0001H0.977138C0.503751 12.0001 0.119995 11.5971 0.119995 11.1001V0.900053C0.119995 0.402997 0.503751 5.34058e-05 0.977138 5.34058e-05H4.90781ZM1.83428 3.00005H4.12V4.20005H1.83428V3.00005ZM6.40571 5.40005V6.60005H1.83428V5.40005H6.40571ZM1.83428 9.00005V7.80005H5.83428V9.00005H1.83428Z",
                                                                                        fill: "#1A7BEE",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "textBlue" },
                                            [
                                              _vm._v(
                                                " Total Hours Tracked " +
                                                  _vm._s(
                                                    _vm.convertSecondsToReadable(
                                                      _vm.timeAggregate
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }